import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Link from "@/utils/link";

import Button from "@/ui/Button";
import { min } from "moment";

/*
    Community Details: Add and manage the basic details to your community profile that showcase your services.
    "Verified" Badge: Indicates to
    the consumer that you have claimed and updated your profile.
    Photo Gallery: Showcase your community with an unlimited number of images.
    Care Options: Indicate the licensing and care types offered in your community.
*/

const freeItems = [
    {
        title: "Community Details",
        description: "Add and manage the basic information for your community.",
    },
    // {
    //     title: "Photo Gallery",
    //     description: "Showcase your community with an unlimited number of images.",
    // },
    // {
    //     title: "Care Options",
    //     description: "Indicate the licensing and care types offered in your community.",
    // },
];

/*
    ALL Badges: VACANCY, COMING SOON, and PREBOOKING badges. Post floor plans or photos of your vacant units and those that are coming soon. Let seniors know you can accommodate an immediate move-in and the type of care offered in the vacant unit.
    Direct Communication: A unique feature that allows seniors to reach you directly by inbox whether it's to book a tour or get more information.
    *Text messaging COMING SOON!
    Branding Enhancement: Add your community or company logo/branding to your listing.
    Detailed Floor Plans: Post ALL unit floorplans and photos of units. A great resource for seniors to plan ahead and join your community waitlist.
    Base Rates: Choose to share base rates. You are more likely to receive financially qualified seniors.
    Incentives: Post your special move-in in- centives to attract more seniors to your community. Everyone loves a great deal!
    Document Upload: Share your brochure, documents, menus, calendars, newsletters directly from your profile.
    Sales Sheets: Who doesn't like to shop and compare? Seniors can download and print a 1-sheet tour guide with all your community profile details and vacancies. We even in- cluded a place for notes.*/

const proItems = [
    {
        title: "Badges",
        description:
            "Instantly signal what's happening in your community with badges that highlight VACANCY, UPCOMING EVENTS, VACANCY SOON, SPECIAL INCENTIVES, PRE-LEASING, and WAITLIST.",
    },
    {
        title: "Lead Ownership",
        description: "Every lead is yours. No shared referrals. No resale.",
    },
    {
        title: "CRM Integration",
        description: "Keep your pipeline moving with live, automatic vacancy updates.",
    },
    {
        title: "Direct Communication",
        description:
            "Make it easy for seniors and families to connect with you directly through inbox messaging.",
    },
    {
        title: "Detailed Floor Plans",
        description:
            "Showcase ALL unit floor plans and unit photos in one place. A powerful tool for seniors who want to plan—and an easy way to encourage future residents to join your waitlist with confidence.",
    },
    {
        title: "Branding Enhancement",
        description:
            "Add your community brand/logo. A branded profile helps your community stand out from competitors.",
    },
    {
        title: "Base Rates",
        description:
            "Choose to share your base rates to attract financially prepared seniors. Communities that display pricing are more likely to receive qualified leads, saving your team time and enhancing conversion rates.",
    },
    {
        title: "Incentives",
        description:
            "Promote special move-in offers to create urgency and drive action. Whether it's a limited-time discount or a move-in bonus, incentives help your community stand out—because everyone loves a great deal!",
    },
    {
        title: "Document Upload",
        description:
            "Upload key resources directly to your profile, including brochures, menus, calendars, newsletters, and other relevant materials. Families can review everything they need in one place.",
    },
    {
        title: "Sales Sheets (Printable 1-Sheet Tour Guide)",
        description:
            'Help seniors "shop and compare" with ease. Premium listings include a downloadable one-page tour guide featuring your community details and vacancies—with space for notes so families can stay organized while touring multiple options.',
    },
    {
        title: "Languages Spoken",
        description:
            "Show the diversity and accessibility of your community by listing all languages spoken by staff and residents. Language is a key factor when choosing care.",
    },
];

const CpPricing = () => {
    const [pricing, setPricing] = useState([]);

    // fetch pricing
    useEffect(() => {
        const fetchData = async () => {
            const res = await fetch("/api/community-portal/billing/getPricing", {
                method: "GET",
            });
            const data = await res.json();
            console.log("getPricing data", data);
            setPricing(data.pricing);
        };

        fetchData();
    }, []);

    return (
        <div id="pricing-section" className="w-full bg-gray-light">
            <div className="container mx-auto ">
                <div className="w-full">
                    <h2 className="px-8 sm:px-16 pt-8 sm:pt-12 pb-6 text-center text-4xl text-primary-500 font-headline font-bold">
                        Plans and Features
                    </h2>

                    {/*<div className="px-8 sm:px-16 flex justify-center text-xl sm:text-2xl font-bold">
                        <p className="max-w-3xl">
                            Start your 14-day free trial today and unlock full access to all
                            our features. Experience the complete range of features, without
                            any commitments. Explore at your own pace. Sign up now and take
                            the first step towards enhancing your visibility and attract
                            more residents!
                        </p>
                    </div>*/}

                    {/* <h3 className="px-8 sm:px-16 mt-8 flex justify-center text-3xl font-bold text-primary-500">
                        Introductory Pricing
                    </h3> */}

                    <div className="h-full mt-2 sm:mt-4 pb-16 px-8 sm:px-16 grid grid-cols-1 sm:grid-cols-3 gap-x-12 gap-y-16">
                        <div className="h-full">
                            <h3 className="px-8 py-4 h-24 xl:h-16 bg-primary-500 text-white text-2xl uppercase font-headline font-bold">
                                Basic Listing
                            </h3>

                            <div className="h-[calc(100%-64px)] px-8 py-8 bg-gray-100 text-base">
                                {/* <h4 className="text-2xl font-bold">FREE</h4> */}

                                <p className="mt-4">
                                    The Basic Listing level simply confirms your presence in
                                    the area. Upgrade to a Membership Listing to be fully
                                    discoverable.
                                </p>

                                {/*<ul className="mt-4 space-y-8">
                                    {freeItems.map((item) => (
                                        <li key={item.title}>
                                            <span className="font-bold mr-2">
                                                {item.title}:
                                            </span>
                                            <span>{item.description}</span>
                                        </li>
                                    ))}
                                </ul>

                                <p className="mt-4">
                                    This listing level simply confirms your presence in the
                                    area.
                                </p>
                                <p className="mt-4">
                                    Upgrade to a Premium Listing to be fully discoverable.{" "}
                                </p>

                                <p className="mt-4">
                                    Premium listings allow seniors, families, and
                                    caseworkers to see:
                                </p>

                                <ul className="list-disc list-inside mt-4">
                                    <li>Live vacancies</li>

                                    <li>Real-time community details</li>

                                    <li>Tour booking</li>

                                    <li>Move-in incentives</li>

                                    <li>Direct messaging</li>

                                    <li>Unlimited leads - NO referral fees</li>

                                    <li>
                                        CRM integration
                                        <br />
                                        …and more.
                                    </li>
                                </ul>

                                <p className="mt-4">
                                    Without a Premium Listing, your vacancies won’t be
                                    visible—and vacancies are what people are searching for.
                                </p>

                                <p className="mt-4">
                                    And remember: when you receive a lead through Purple
                                    Door Finders, you own it.
                                </p>*/}
                            </div>
                        </div>

                        <div className="sm:col-span-2">
                            <h3 className="px-8 py-4 h-24 xl:h-16 bg-primary-500 text-white text-2xl uppercase font-headline font-bold">
                                Membership Listing
                            </h3>

                            <div className="px-8 py-8 bg-gray-100">
                                {/*<table className="sm:hidden text-base">
                                    <thead>
                                        <tr>
                                            <th className="pr-8 py-2">Units</th>
                                            <th className="pr-8 py-2">
                                                Annual Subscription
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pricing.map((item) => (
                                            <tr key={item.minUnits}>
                                                <td className="px-2 py-2 font-bold text-center flex flex-col justify-start">
                                                    {item.minUnits}
                                                    {""}
                                                    {item.maxUnits === 999999
                                                        ? "+"
                                                        : `-${item.maxUnits}`}
                                                </td>
                                                <td className="px-2 py-2">
                                                    <div className="text-xl">
                                                        <span className="font-bold">
                                                            ${item.yearly}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <table className="hidden sm:block text-lg">
                                    <tbody>
                                        <tr>
                                            <td className="pr-8 py-2">Units</td>
                                            {pricing.map((item) => (
                                                <td
                                                    key={item.minUnits}
                                                    className="px-4 py-2 font-bold text-center"
                                                >
                                                    {item.minUnits}{" "}
                                                    {item.maxUnits === 999999
                                                        ? "+"
                                                        : `- ${item.maxUnits}`}
                                                </td>
                                            ))}
                                        </tr>

                                        <tr>
                                            <td className="pr-8 py-2">
                                                Annual Subscription
                                            </td>
                                            {pricing.map((item) => (
                                                <td
                                                    key={item.minUnits}
                                                    className="px-4 py-2"
                                                >
                                                    <div className="text-2xl">
                                                        <span className="font-bold">
                                                            ${item.yearly}
                                                        </span>
                                                    </div>
                                                </td>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>*/}

                                <p className="mt-4 text-xl font-bold">
                                    Everything in Basic Listing, plus:
                                </p>

                                {/*<ul className="mt-6 text-lg grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8">
                                    {proItems.map((item) => (
                                        <li key={item.title}>
                                            <span className="font-bold mr-2">
                                                {item.title}:
                                            </span>
                                            <span>{item.description}</span>
                                        </li>
                                    ))}
                                </ul>*/}

                                <div className="mt-6 text-lg grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8">
                                    <ul className="flex flex-col space-y-8 text-base">
                                        <li key="first item">
                                            <span className="font-bold mr-2">Badges:</span>
                                            <span>
                                                Instantly signal what's happening in your
                                                community with badges that highlight{" "}
                                                <span className="font-bold text-primary-500">
                                                    VACANCY, UPCOMING EVENTS, VACANCY SOON,
                                                    SPECIAL INCENTIVES, PRE-LEASING,
                                                </span>{" "}
                                                and{" "}
                                                <span className="font-bold text-primary-500">
                                                    WAITLIST.
                                                </span>
                                            </span>
                                        </li>

                                        {proItems
                                            .filter((_, i) => i >= 1 && i < 6)
                                            .map((item) => (
                                                <li key={item.title}>
                                                    <span className="font-bold mr-2">
                                                        {item.title}:
                                                    </span>
                                                    <span>{item.description}</span>
                                                </li>
                                            ))}
                                    </ul>

                                    <ul className="flex flex-col space-y-8 text-base">
                                        {proItems
                                            .filter((_, i) => i >= 6)
                                            .map((item) => (
                                                <li key={item.title}>
                                                    <span className="font-bold mr-2">
                                                        {item.title}:
                                                    </span>
                                                    <span>{item.description}</span>
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CpPricing;
